exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h4[data-v-1a8a4ce5]{font-size:24px;font-weight:700;margin:0;padding-top:14px}.btn-wrap[data-v-1a8a4ce5],h4[data-v-1a8a4ce5]{padding-left:32px;padding-right:32px}.btn-wrap[data-v-1a8a4ce5]{padding-bottom:32px;text-align:center}.back-button[data-v-1a8a4ce5]{position:absolute;top:6px;left:0;z-index:40;width:40px;height:40px;padding:10px;cursor:pointer}.back-button svg[data-v-1a8a4ce5]{display:block;width:16px;height:16px}@media(max-width:767.98px){h4[data-v-1a8a4ce5]{padding-left:16px}}", ""]);

// exports
